import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { Dealer } from "src/app/shared/models/Dealer.model";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-user-profile",
	templateUrl: "./user-profile.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class UserProfileComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();
	@Input() currentUserProfileEdit: boolean;
	@Output() currentUserProfileEditChange = new EventEmitter<boolean>();

	@Input() dealerList: Dealer[];
	@Output() dealerListChange = new EventEmitter<Dealer[]>();
	@Input() dealerSelected: string;
	@Output() dealerSelectedChange = new EventEmitter<string>();

	@Input() user: User;
	@Output() userChange = new EventEmitter<User>();

	userRoles = [];

	constructor(public app: AppService, public userService: UserService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.init();
		this.assignRolesFromCurrentUser();
	}

	async init() {}

	assignRolesFromCurrentUser() {
		if (this.userService.user.role > 1) {
			this.userRoles.push({
				label: "Venue User",
				value: 1,
			});
		}
		if (this.userService.user.role >= 2) {
			this.userRoles.push({
				label: "Venue Admin",
				value: 2,
			});
		}
		if (this.userService.user.role >= 3) {
			this.userRoles.push({
				label: "Dealer User",
				value: 3,
			});
		}
		if (this.userService.user.role >= 4) {
			this.userRoles.push({
				label: "Dealer Admin",
				value: 4,
			});
		}
		if (this.userService.user.role >= 5) {
			this.userRoles.push({
				label: "Super Admin",
				value: 5,
			});
		}
		if (this.userService.user.role === 6) {
			this.userRoles.push({
				label: "Holy One",
				value: 6,
			});
		}
	}

	async onSave() {
		await this.focuslink.userEdit(this.user);
		this.userService.user.firstName = this.user.firstName;
		this.userService.user.lastName = this.user.lastName;
		this.userService.user.organization = this.user.organization;
		this.userService.userSubscription.next(this.userService.user);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Your profile has been updated.` });
		this.changesToSaveChange.emit(false);
	}

	async userDealerSelect() {
		if (this.user.role === 3 || this.user.role === 4) {
			this.user.organization = this.dealerList.find((i) => i.key === this.user.dealerKey).name;
		} else if (this.user.role === 5) {
			this.user.organization = "Focus POS Systems";
		}
	}

	async userDelete(rec: User) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete ${rec.firstName} ${rec.lastName} from existence?`,
			accept: async () => {
				await this.focuslink.userDelete(rec.key);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
